import type { PGD } from "../types";

export const pgdPhenazoneLidocaineAom: PGD = {
  id: "pgd-7a-phenazlido-aom",
  reference: "7a",
  version: "1.0",
  drugRef: "phenazone_lidocaine_ear_drops",
  indication:
    "Acute otitis media — symptom relief in moderate/severe cases WITHOUT perforation",
  validFrom: "2024-01-31",
  expiryDate: "2027-01-30",
  frameworkType: "pharmacy_first",
  population: {
    ageRange: { min: 1, max: 17 },
    pregnancyAllowed: "yes_if_16_plus",
    breastfeedingAllowed: true,
    notes:
      "ONLY when no perforation and patient does NOT meet antibiotic eligibility criteria",
  },
  duration: {
    days: 7,
    comment: "Up to 7 days — longer than other Pharmacy First treatments",
  },
  doseBands: [
    {
      id: "phenaz-all",
      resolveBy: "single",
      dose: "4 drops",
      frequency: "TWO to THREE times a day",
      comment:
        "Single dose band — all ages 1-17. Warm bottle in hand 1-2 minutes before instilling.",
      formulations: [
        {
          formulationId: "phenaz-lido-15g",
          instruction:
            "Instil 4 drops into the affected ear(s) 2 to 3 times daily for up to 7 days",
          quantity: { bottles: 1, label: "1 × 15g bottle" },
        },
      ],
    },
  ],
  preSupplyChecks: [
    { id: "ex-consent-refused", question: "Has the patient/carer refused consent?" },
    { id: "ex-h2o2-allergy", question: "Hypersensitivity to phenazone, lidocaine, or any component of the formulation?" },
    { id: "ex-perforation", question: "Known or suspected perforation of the tympanic membrane? (including otorrhoea, myringotomy, grommet or ventilation tube)", comment: "CRITICAL — ear drops are CONTRAINDICATED with perforation" },
    { id: "ex-foreign-body", question: "Evidence of, or suspected, foreign body in the ear canal?" },
    { id: "ex-glue-ear", question: "Otitis media with visible effusion (glue ear)?" },
    { id: "ex-temp-39", question: "Temperature over 39°C?", linkedVitalType: "temperature" },
    { id: "ex-cholesteatoma", question: "Known cholesteatoma?" },
    { id: "ex-bloody-discharge", question: "Bloody or blood-stained discharge from ear?", comment: "Possible cancer — refer urgently" },
    { id: "ex-g6pd", question: "Known haemoglobinopathy or Glucose-6-phosphate dehydrogenase (G6PD) deficiency, or other risk factor for methaemoglobinaemia?" },
  ],
  cautions: [
    {
      id: "caution-antidoping",
      text: "Anti-doping: individuals subject to anti-doping tests should be advised against using Otigo® — may give a positive result.",
    },
  ],
  counselling: [
    "Warm the bottle in your hand for 1–2 minutes before use",
    "Tilt head sideways and instil 4 drops into the affected ear canal",
    "Remain with the ear uppermost for a few minutes after instilling",
    "Use 2 to 3 times daily for up to 7 days",
    "Paracetamol or ibuprofen (OTC, weight-appropriate dose) should also be used regularly for pain",
    "Decongestants and antihistamines do NOT help with AOM symptoms — do not use",
    "Return to pharmacy if symptoms worsen rapidly or child becomes very unwell",
    "Return if no improvement within 3–5 days for pharmacist reassessment",
    "STOP using drops and return immediately if any discharge appears from the ear — this may indicate the eardrum has perforated",
  ],
  counsellingPoints: [
    { text: "Warm the bottle in your hand for 1–2 minutes before use" },
    { text: "Tilt head sideways and instil 4 drops into the affected ear canal" },
    { text: "Remain with the ear uppermost for a few minutes after instilling" },
    { text: "Use 2 to 3 times daily for up to 7 days" },
    { text: "Paracetamol or ibuprofen (OTC, weight-appropriate dose) should also be used regularly for pain" },
    { text: "Decongestants and antihistamines do NOT help with AOM symptoms — do not use" },
    { text: "Return to pharmacy if symptoms worsen rapidly or child becomes very unwell" },
    { text: "Return if no improvement within 3–5 days for pharmacist reassessment" },
    { text: "STOP using drops and return immediately if any discharge appears from the ear — this may indicate the eardrum has perforated" },
  ],
  outcomeLinkRefs: ["target-rti-leaflet", "nhs-ear-infection"],
};
